var map = {
	"./auto-login-check": 5608,
	"./auto-login-check.js": 5608,
	"./birth-card-calculator": 4136,
	"./birth-card-calculator.js": 4136,
	"./birthday-select": 633,
	"./birthday-select.js": 633,
	"./chinese-zodiac-sign-datepicker": 2898,
	"./chinese-zodiac-sign-datepicker.js": 2898,
	"./compatibility/astrology": 4793,
	"./compatibility/astrology.js": 4793,
	"./compatibility/chooser": 7308,
	"./compatibility/chooser.js": 7308,
	"./compatibility/types/chinese": 1011,
	"./compatibility/types/chinese.js": 1011,
	"./compatibility/types/zodiac": 4044,
	"./compatibility/types/zodiac.js": 4044,
	"./cordial": 8469,
	"./cordial.js": 8469,
	"./date-picker": 8126,
	"./date-picker.js": 8126,
	"./ga-events": 7460,
	"./ga-events.js": 7460,
	"./kc-sale-message": 1082,
	"./kc-sale-message.js": 1082,
	"./keen": 7027,
	"./keen-slider": 1855,
	"./keen-slider.js": 1855,
	"./keen.js": 7027,
	"./logged-in": 2884,
	"./logged-in.js": 2884,
	"./logged-out": 9423,
	"./logged-out.js": 9423,
	"./modals": 7357,
	"./modals/": 7357,
	"./modals/index": 7357,
	"./modals/index.js": 7357,
	"./modals/journal": 1959,
	"./modals/journal.js": 1959,
	"./modals/login": 1230,
	"./modals/login.js": 1230,
	"./modals/password": 6143,
	"./modals/password.js": 6143,
	"./modals/profile": 9327,
	"./modals/profile.js": 9327,
	"./modals/signup": 4323,
	"./modals/signup.js": 4323,
	"./modals/sms": 9776,
	"./modals/sms.js": 9776,
	"./modals/vip-unsubscribe": 6313,
	"./modals/vip-unsubscribe.js": 6313,
	"./nav/articles": 506,
	"./nav/articles.js": 506,
	"./nav/bar-mobile": 1672,
	"./nav/bar-mobile.js": 1672,
	"./nav/mobile-menu": 4926,
	"./nav/mobile-menu.js": 4926,
	"./nav/mobile-nav": 3795,
	"./nav/mobile-nav.js": 3795,
	"./nav/submenu": 8415,
	"./nav/submenu.js": 8415,
	"./panel-loader": 1954,
	"./panel-loader.js": 1954,
	"./policy-consent": 7841,
	"./policy-consent.js": 7841,
	"./product-message": 4943,
	"./product-message.js": 4943,
	"./promo-message": 1573,
	"./promo-message.js": 1573,
	"./reading-header-price": 9573,
	"./reading-header-price.js": 9573,
	"./sale-message": 3215,
	"./sale-message.js": 3215,
	"./service-contact-form": 7305,
	"./service-contact-form.js": 7305,
	"./show-details": 1446,
	"./show-details.js": 1446,
	"./smooth-scroll": 8529,
	"./smooth-scroll.js": 8529,
	"./upsell-button": 2099,
	"./upsell-button.js": 2099,
	"./user/menu-desktop": 8673,
	"./user/menu-desktop.js": 8673,
	"./user/menu-details": 4280,
	"./user/menu-details.js": 4280,
	"./user/menu-login": 4755,
	"./user/menu-login.js": 4755,
	"./user/menu-mobile": 3722,
	"./user/menu-mobile.js": 3722,
	"./zodiac-dropdown": 8346,
	"./zodiac-dropdown.js": 8346,
	"./zodiac-sign-picker": 474,
	"./zodiac-sign-picker.js": 474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1492;